import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import { React } from "react";
import { DateRangePicker } from "react-date-range";

export default function DateRangeSelector({ value, onChange }) {
  return <DateRangePicker ranges={[value]} onChange={onChange} />;
}
